import * as Yup from 'yup';

export const resetPasswordSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('please enter your email'),
});